import React, { useState } from 'react';
import { Menu, X, User, Sun, Wind, AlertCircle } from 'lucide-react';
import { LanguageSelector } from './LanguageSelector';
import { LoginModal } from './LoginModal';
export function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const SNC = 'https://www.sylmarneighborhoodcouncil.org/';
  // Cada enlace apunta a un destino real: ancla en la pagina o el sitio oficial del SNC.
  const navLinks: {
    label: string;
    href: string;
    external?: boolean;
  }[] = [{
    label: 'HOME',
    href: '#top'
  }, {
    label: 'ABOUT US',
    href: SNC,
    external: true
  }, {
    label: 'AGENDAS & MINUTES',
    href: SNC,
    external: true
  }, {
    label: 'AGENDA REQUESTS',
    href: SNC,
    external: true
  }, {
    label: 'NEWS',
    href: '#news'
  }, {
    label: 'CALENDAR',
    href: '#calendar'
  }, {
    label: 'COMMITTEES',
    href: SNC,
    external: true
  }, {
    label: 'CONTACT',
    href: '#next-meeting'
  }];
  return <header className="sticky top-0 z-50 w-full bg-white shadow-md" data-id="element-152" data-mp="elpu8z79whho">
      {/* City of LA Top Bar */}
      <div className="bg-charcoal text-white text-xs py-1.5 px-4 md:px-8 flex justify-between items-center" data-id="element-153" data-mp="jnf96pxm9fb1">
        <div className="flex items-center gap-2" data-id="element-154" data-mp="ojnoq4fq7aiq">
          <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/Seal_of_Los_Angeles%2C_California.svg/1024px-Seal_of_Los_Angeles%2C_California.svg.png" alt="City of Los Angeles Seal" className="w-4 h-4" data-id="element-155" data-mp="3n4f8b19jifmn" />
          <span data-id="element-156" data-mp="5mw0rhp8o78c">An Official Website of the City of Los Angeles</span>
        </div>
        <div className="flex items-center gap-4" data-id="element-157" data-mp="5op8z1fi2zig">
          <div className="hidden md:flex gap-4" data-id="element-158" data-mp="34bth4u9kvd8e">
            <a href="https://lacity.gov/" target="_blank" rel="noopener noreferrer" className="hover:text-sylmar transition-colors" data-id="element-159" data-mp="34b1uwa1verus">
              City Services
            </a>
            <a href="https://lacity.gov/residents" target="_blank" rel="noopener noreferrer" className="hover:text-sylmar transition-colors" data-id="element-160" data-mp="2wb5bmkttxv94">
              City Directory
            </a>
          </div>
          {/* Selector de idioma (visible en todos los tamaños) */}
          <LanguageSelector variant="dark" data-id="element-161" data-mp="2iei27ikoxcmb" />
        </div>
      </div>

      {/* Main Header */}
      <div className="px-4 md:px-8 py-3 flex justify-between items-center" data-id="element-162" data-mp="2df5fcxttk5jq">
        {/* Left: Logo */}
        <a href="#top" className="flex-shrink-0" data-id="element-163" data-mp="2s8iec4ee3i4j">
          <img src="https://cdn.magicpatterns.com/uploads/b19k3B7qcY9GvykkPkXLub/ChatGPT_Image_2_jul_2026,_00_15_36.png" alt="Sylmar Neighborhood Council" className="h-16 md:h-24 object-contain transition-transform hover:scale-105 notranslate" data-id="element-164" data-mp="2nb8s0xmarmkx" />
        </a>

        {/* Center: Weather (Desktop) */}
        <div className="hidden lg:flex flex-col items-center justify-center text-sm text-gray-600 px-4" data-id="element-165" data-mp="a6vdr16znynl">
          <div className="flex items-center gap-4 mb-1.5" data-id="element-166" data-mp="f1sms849q80h">
            <div className="flex items-center gap-1.5 font-bold text-charcoal" data-id="element-167" data-mp="155jzopmwnmn">
              <Sun className="w-5 h-5 text-amber-500" data-id="element-168" data-mp="54xmpkscjzk3" />
              <span data-id="element-169" data-mp="57s9vk2qvyh7">
                <span className="notranslate" data-id="element-170" data-mp="svjudayfvhtk">Sylmar</span>: 72°F (22°C) Soleado
              </span>
            </div>
            <div className="w-px h-4 bg-gray-200" data-id="element-171" data-mp="xuwj618veyys"></div>
            <div className="flex items-center gap-1.5" data-id="element-172" data-mp="xwh91dk8ptqb">
              <Wind className="w-4 h-4 text-sky" data-id="element-173" data-mp="k1x3nz9394r8" />
              <span data-id="element-174" data-mp="k15fh9htm9az">15 mph NE</span>
            </div>
          </div>
          <div className="flex items-center gap-1.5 bg-red-50 text-red-700 px-3 py-0.5 rounded-full border border-red-100 text-xs shadow-sm cursor-pointer hover:bg-red-100 transition-colors" data-id="element-175" data-mp="o30iqjjbawre">
            <AlertCircle className="w-3.5 h-3.5" data-id="element-176" data-mp="1glnv9ak8t3gv" />
            <span className="font-bold tracking-wide" data-id="element-177" data-mp="3p1nmffxieh3f">
              Alerta: Aviso de Bandera Roja
            </span>
          </div>
        </div>

        {/* Right: Contact & Login (Desktop) */}
        <div className="hidden xl:flex items-center gap-6" data-id="element-178" data-mp="3f3r9qjoxbe37">
          <div className="text-right text-xs text-charcoal-light notranslate" data-id="element-179" data-mp="3f414ekkwy9f8">
            <a href="tel:8188338737" className="font-bold text-charcoal text-sm hover:text-sylmar transition-colors block mb-0.5" data-id="element-180" data-mp="3b3h7ni4957tm">
              (818) 833-8737
            </a>
            <p data-id="element-181" data-mp="6ohcbovzax1r">13521 Hubbard St.</p>
            <p data-id="element-182" data-mp="1x7qkzdjwdv5">Sylmar, CA 91342</p>
          </div>
          <button onClick={() => setIsLoginOpen(true)} className="flex items-center gap-2 border-2 border-sylmar text-sylmar hover:bg-sylmar hover:text-white px-5 py-2 rounded-md font-bold transition-colors" data-id="element-183" data-mp="1vwm0xca722z">
            <User className="w-4 h-4" data-id="element-184" data-mp="pmtozkm3mp23" />
            LOGIN
          </button>
        </div>

        {/* Mobile/Tablet Right: Weather + Menu */}
        <div className="xl:hidden flex items-center gap-4" data-id="element-185" data-mp="28alfi9z0zmi6">
          <div className="flex flex-col items-end text-xs" data-id="element-186" data-mp="2d8mvgm15n5pf">
            <div className="flex items-center gap-1 font-bold text-charcoal" data-id="element-187" data-mp="2d8wq4mx5a11g">
              <Sun className="w-4 h-4 text-amber-500" data-id="element-188" data-mp="2h9gmho9w90mj" />
              <span data-id="element-189" data-mp="2m9bdrsxkzs84">72°F</span>
            </div>
            <div className="flex items-center gap-1 text-red-700 font-bold text-[10px] mt-0.5 bg-red-50 px-2 py-0.5 rounded-full border border-red-100" data-id="element-190" data-mp="2ma4as26qn3d2">
              <AlertCircle className="w-3 h-3" data-id="element-191" data-mp="2w790ud3pfiz5" />
              <span data-id="element-192" data-mp="2w5xwoc6ck97i">Alerta</span>
            </div>
          </div>
          <button className="p-1 text-charcoal hover:text-sylmar" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-193" data-mp="30xpg82r35eo5">
            {isMobileMenuOpen ? <X className="w-8 h-8" data-id="element-194" data-mp="39zfftvv4fjx0" /> : <Menu className="w-8 h-8" data-id="element-195" data-mp="39wsxd16ozk00" />}
          </button>
        </div>
      </div>

      {/* Desktop Navigation */}
      <nav className="hidden lg:block bg-sylmar-light border-t border-sylmar/10" data-id="element-196" data-mp="1evhewgqnpnv8">
        <ul className="flex justify-center flex-wrap px-4" data-id="element-197" data-mp="1eted6zg566ao">
          {navLinks.map((link, index) => <li key={index} data-id="element-198" data-mp="1olk4s82helpc" data-mpi={index}>
              <a href={link.href} target={link.external ? '_blank' : undefined} rel={link.external ? 'noopener noreferrer' : undefined} className="block px-4 py-3 text-sm font-bold text-charcoal hover:text-sylmar hover:bg-white transition-colors border-b-2 border-transparent hover:border-sylmar" data-id="element-199" data-mp="1oltvxyz9iywm">
                {link.label}
              </a>
            </li>)}
        </ul>
      </nav>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && <nav className="lg:hidden bg-white border-t border-gray-100 absolute w-full shadow-xl" data-id="element-200" data-mp="22m4nz5cb6jjd">
          <ul className="flex flex-col py-2" data-id="element-201" data-mp="d6ng4za7lyii">
            {navLinks.map((link, index) => <li key={index} data-id="element-202" data-mp="88vdba810rzj" data-mpi={index}>
                <a href={link.href} target={link.external ? '_blank' : undefined} rel={link.external ? 'noopener noreferrer' : undefined} className="block px-6 py-3 text-sm font-bold text-charcoal hover:text-sylmar hover:bg-sylmar-light transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-203" data-mp="2junrejz7yaz6">
                  {link.label}
                </a>
              </li>)}
            <li className="px-6 py-4 border-t border-gray-100 mt-2" data-id="element-204" data-mp="216ispqxf5g78">
              <button onClick={() => {
            setIsMobileMenuOpen(false);
            setIsLoginOpen(true);
          }} className="w-full flex justify-center items-center gap-2 bg-sylmar text-white px-6 py-3 rounded-md font-bold transition-colors" data-id="element-205" data-mp="264u3q4zg9wr1">
                <User className="w-4 h-4" data-id="element-206" data-mp="3lhww0cx9kjek" />
                LOGIN
              </button>
            </li>
          </ul>
        </nav>}

      {/* Modal de registro / bienvenida a la comunidad */}
      <LoginModal open={isLoginOpen} onClose={() => setIsLoginOpen(false)} data-id="element-207" data-mp="2ebttu436crjj" />
    </header>;
}